<template>
  <button
    v-if="hasValue"
    type="button"
    :title="computedTitle"
    :class="btnClass"
    class="inline-flex items-center p-0 border-0 bg-transparent cursor-pointer hover:opacity-75 focus:outline-none text-[#828282]"
    @click="copy"
  >
    <slot>
      <span
        class="k-copy"
        :class="iconClass"
      />
    </slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonCopy',
  props: {
    text: {
      type: [String, Number],
      default: '',
    },
    fieldLabel: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    btnClass: {
      type: [String, Array, Object],
      default: '',
    },
    iconClass: {
      type: [String, Array, Object],
      default: 'text-[16px]',
    },
    showToast: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasValue() {
      return this.text !== null && this.text !== undefined && this.text !== ''
    },
    computedLabel() {
      return this.fieldLabel || this.label || ''
    },
    computedTitle() {
      if (this.title) return this.title
      if (this.computedLabel) return `Salin ${this.computedLabel}`
      return 'Salin'
    },
    computedMessage() {
      if (this.message) return this.message
      if (this.computedLabel) return `${this.computedLabel} berhasil disalin`
      return 'Berhasil disalin'
    },
  },
  methods: {
    async copy() {
      const textToCopy = this.text !== null && this.text !== undefined ? String(this.text) : ''
      if (!textToCopy) return

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(textToCopy)
        } else {
          this.fallbackCopy(textToCopy)
        }
        this.onSuccess()
      } catch (err) {
        try {
          this.fallbackCopy(textToCopy)
          this.onSuccess()
        } catch (fallbackErr) {
          this.onError(fallbackErr)
        }
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.top = '0'
      textarea.style.clip = 'rect(0, 0, 0, 0)'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    },
    onSuccess() {
      if (this.showToast && this.$toast_success) {
        this.$toast_success({
          title: 'Berhasil',
          message: this.computedMessage,
        })
      }
      this.$emit('copied', this.text)
      this.$emit('success', this.text)
    },
    onError(err) {
      if (this.$toast_error) {
        this.$toast_error({
          title: 'Gagal',
          message: 'Gagal menyalin ke clipboard',
        })
      }
      this.$emit('error', err)
    },
  },
}
</script>
